<div class="d-flex flex-column gap-2">

  @if(showLTClientSelectOption)
  {
   <p>
      <mat-button-toggle-group appearance="standard"
        [(ngModel)]="selectByLTClient"
        (change)="changeSelectionMethod($event)">
        <mat-button-toggle [value]="true">LOS Talker Client</mat-button-toggle>
        <mat-button-toggle [value]="false">Company Id and Name</mat-button-toggle>
      </mat-button-toggle-group>
    </p>
  }

  @if(failedLoading === false)
  {
    @if(selectByLTClient === true)
    {
      <app-client-dropdown-view #clientView
          [clients]="clients"
          (itemSelected)="getClientFromView($event)"
          (loadingFailed)="setFailedLoading($event)"></app-client-dropdown-view>

          @if(selectedClient !== null) {
            <app-integration-dropdown-view
              [client]="selectedClient"
              [onlyDataSwap]="onlyDataSwap"
              [onlyFastFetch]="onlyFastFetch"
              [onlyUseInfo]="false"
              (itemSelected)="getIntegrationFromView($event)"
              (loadingFailed)="setFailedLoading($event)"></app-integration-dropdown-view>

            @if(selectedIntegration() !== null && selectIdentifierForClients === true) {
              <app-identifier-dropdown-view #identifierView
                [destination]="selectedDestination()"
                [integration]="selectedIntegration()"
                (itemSelected)="getIdentifierFromView($event)"
                (itemSelectedFromOverride)="getIdentifierFromView($event)"
                (loadingFailed)="setFailedLoading($event)"
                [onlyDataSwap]="onlyDataSwap"
                [onlyFastFetch]="onlyFastFetch"
                [overrideIdentifierId]="identifierId"
                [overrideIdentifierName]="identifierName"></app-identifier-dropdown-view>
            }
          }
    }
    @else {
      <app-destinations-dropdown-view #destinationView
          (itemSelected)="getDestinationFromView($event)"
          (itemSelectedFromOverride)="getDestinationFromView($event)"
          (loadingFailed)="setFailedLoading($event)"
          [overrideEndpointName]="overrideDestinationName()"
          [destinationStrs]="destinationStrs()"></app-destinations-dropdown-view>

      @if (selectedDestination())
      {
        <app-identifier-dropdown-view #identifierView
          [destination]="selectedDestination()"
          (itemSelected)="getIdentifierFromView($event)"
          (itemSelectedFromOverride)="getIdentifierFromView($event)"
          (loadingFailed)="setFailedLoading($event)"
          [onlyDataSwap]="onlyDataSwap"
          [onlyFastFetch]="onlyFastFetch"
          [overrideIdentifierId]="identifierId"
          [overrideIdentifierName]="identifierName"></app-identifier-dropdown-view>
      }
    }

  }
</div>
